import React, { FC } from 'react';
import { Wrapper } from './styled';
import { Icon } from 'kl-b2c-ui-kit';

export const PlusMinus: FC<{ plus?: boolean }> = ({ plus }) => (
    <Wrapper>
        <Icon name={plus ? 'Plus' : 'Cross'} size={24} color={'teal'} />
    </Wrapper>
);
